import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = N. */
export const FORCE_PIVOT: Record<string, number> = {
  n: 1,
  kn: 1000,
  lbf: 4.44822,
  kgf: 9.80665,
};

export const transformForce = createPivotTransformer(FORCE_PIVOT);
